//
// Generated class AccountingJournalEntryTemplate
//

/// <reference path="AccountingJournalEntryTemplate_ManagedObject.ts" />

class AccountingJournalEntryTemplate extends AccountingJournalEntryTemplate_ManagedObject
{

}
